/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Tag } from '@blend/enterprise-components';

export enum ECloseAuditEventNames {
  CLOSING_DOCUMENTS_REMOVED = 'CLOSING_DOCUMENTS_REMOVED',
  SIGNED_DOCUMENTS_RETRIEVED = 'SIGNED_DOCUMENTS_RETRIEVED',
  PRE_CLOSING_DOCUMENTS_SENT = 'PRE_CLOSING_DOCUMENTS_SENT',
}
export type ECloseAuditEventName = keyof typeof ECloseAuditEventNames;

export enum ECloseDocumentTypes {
  ADDITIONAL_CLOSING_DOCUMENT = 'ADDITIONAL_CLOSING_DOCUMENT',
  PRELIMINARY_CLOSING_DOCUMENTS = 'PRELIMINARY_CLOSING_DOCUMENTS',
  TRAILING_DOCUMENTS = 'TRAILING_DOCUMENTS',
  RON_ACTIVITY_LOG = 'RON_ACTIVITY_LOG',
}
export type ECloseDocumentType = keyof typeof ECloseDocumentTypes;

export const PRINT_FOR_CLOSING_DAY_TAG = <Tag id="it-PrintIndicator" text="PRINT FOR CLOSING DAY" theme="warning" />;
export const PENDING_SIGNATURE_TAG = <Tag id="it-SignedIndicator" text="PENDING BORROWER SIGNATURE" theme="warning" />;
export const SIGNATURE_COMPLETED_TAG = <Tag id="it-SignedIndicator" text="SIGNED" theme="default" />;
